/* Barra de un escalón (Carlos 2026-09-14): desde $1,500 envío gratis y regalo snack sorpresa juntos.
   El regalo (variante $0, producto oculto) se agrega o quita solo según el subtotal sin el regalo.
   Una lectura inicial y una por cambio real. No intercepta fetch ni usa polling. */
(() => {
  const bar = document.getElementById('sd-envio');
  if (!bar) return;
  const ENVIO = 150000, REGALO = 150000, GIFT = 45447637958838, MINIMO = 0; // sin pedido mínimo desde el 30 sep 2026 (antes 49900, Carlos 2026-09-16), igual que la condición de las tarifas de envío
  const text = document.getElementById('sd-envio-tx');
  const fill = document.getElementById('sd-envio-fill');
  const track = fill && fill.parentElement;
  if (track) track.style.background = 'rgba(255,253,244,.22)';
  let pending = false, dirty = false, ajustando = false;
  const root = window.Shopify?.routes?.root || '/';
  const money = cents => (cents / 100).toLocaleString('es-MX', {style: 'currency', currency: 'MXN', maximumFractionDigits: 0});
  const post = (url, body) => fetch(root + url, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)});
  async function refresh() {
    if (pending) { dirty = true; return; }
    pending = true;
    try {
      const response = await fetch(`${root}cart.js`, {headers: {'Accept': 'application/json'}});
      if (!response.ok) throw new Error('No se pudo leer el carrito');
      const cart = await response.json();
      const giftLine = cart.items.find(i => i.variant_id === GIFT);
      const total = cart.total_price; // ya con cupones: igual que el envío gratis de Shopify (el regalo vale $0)
      const productos = cart.items.filter(i => i.variant_id !== GIFT).length;
      // regalo automático: una sola pieza, solo desde $1,500 sin contar el regalo
      if (!ajustando) {
        let cambio = null;
        if (total >= REGALO && !giftLine) cambio = post('cart/add.js', {items: [{id: GIFT, quantity: 1}]});
        else if (giftLine && (total < REGALO || giftLine.quantity !== 1)) cambio = post('cart/change.js', {id: giftLine.key, quantity: total < REGALO ? 0 : 1});
        if (cambio) {
          ajustando = true;
          await cambio.catch(() => {});
          ajustando = false; pending = false;
          if (location.pathname.replace(root, '/').startsWith('/cart')) { location.reload(); return; }
          return refresh();
        }
      }
      document.documentElement.classList.toggle('sd-bajo-minimo', productos > 0 && total < MINIMO);
      bar.toggleAttribute('hidden', !productos);
      bar.dataset.ver = productos ? '1' : '0';
      fill.style.width = `${Math.min(100, total / REGALO * 100)}%`;
      if (total < MINIMO) text.innerHTML = `Pedido mínimo <b>$499</b>. Te faltan <b>${money(MINIMO - total)}</b> para poder pagar.`;
      else if (total >= REGALO) text.innerHTML = '<b>¡Listo!</b> Envío gratis y tu <b>snack de edición limitada de regalo</b> ya van en tu pedido.';
      else text.innerHTML = `Te faltan <b>${money(ENVIO - total)}</b> para <b>envío gratis y un snack de edición limitada de regalo</b>.`;
      // Auditoría 09-17 (tarea 340): en /cart "Ver carrito" recargaba la misma página. Ahí el botón lleva a seguir comprando, y se oculta cuando ya no falta nada.
      const cta = bar.querySelector('.sd-cta');
      if (cta && location.pathname.replace(root, '/').startsWith('/cart')) {
        cta.textContent = 'Agregar más'; cta.href = root + 'collections/seleccion-del-depot';
        cta.hidden = total >= REGALO;
      }
    } catch (_) { bar.removeAttribute('data-ver'); }
    finally { pending = false; if (dirty) { dirty = false; refresh(); } }
  }
  function afterCartUpdate(event) {
    // Horizon emite el evento antes del POST y resuelve promise con el carrito confirmado.
    if (event.promise && typeof event.promise.then === 'function') event.promise.then(refresh).catch(() => {});
    else refresh();
  }
  document.addEventListener('shopify:cart:lines-update', afterCartUpdate);
  document.addEventListener('shopify:cart:discount-update', afterCartUpdate);
  window.addEventListener('pageshow', refresh);
  // Tarea 31: el agregado rápido de portada y colección solo reescribe .cart-counter; se observa ese contador.
  document.querySelectorAll('.cart-counter').forEach((counter) => {
    new MutationObserver(() => { if (!ajustando) refresh(); }).observe(counter, {childList: true, characterData: true, subtree: true});
  });
})();
